import type { ChainId, ExecutableToken, } from "@types";
import { getRate, } from "./getRate";
import { getChainedTokens, } from "@bracket/addressbook";
import { bi, } from "@helpers";
import { cachedValue, cacheValue, } from "./cache";


export declare type GetRatesForChainResult = Record<string, bigint>;


/**
 * @deprecated we only load rates off chain 1.
 * @param param0 
 * @returns 
 */
export const getRatesForChain = async ({
	chain,
}: { chain: ChainId, }): Promise<GetRatesForChainResult> => {

	const result = {} as Record<string, bigint>;
	const ratedTokens = getChainedTokens(chain, { parity: false, });
	const parityTokens = getChainedTokens(chain, { parity: true, exclude: [ "ETH", ], });
	const tokens = [ ...ratedTokens, ...parityTokens ];
	for( const token of tokens ) {
		result[token.label] = token.parity ? bi(1) : await getRate({ token, });
	}
	return result;
}
